export const RECENT_ACTIVITY_TEXT = Object.freeze({
  card: {
    title: 'Actividad Reciente',
    loading: 'Cargando actividad...',
    emptyTitle: 'Sin actividad reciente',
    emptyCustomerDescription: 'No hay movimientos registrados para este cliente.',
    emptySaleDescription: 'No hay movimientos registrados para este negocio.',
    viewHistory: 'Ver todo el historial',
  },
  row: {
    defaultTitle: 'Actividad registrada',
    defaultActor: 'Sistema',
    recent: 'Reciente',
  },
});